import { defineStore } from "pinia";

export const usePaySlipAnnexStore = defineStore('paySlipAnnex', {
    state: () => ({
        annexId: null,
        paySlipAnnex: {},
        paySlipAnnexes: [],
    }),
    actions: {
        getMax() {
            if(this.paySlipAnnexes.length > 0) {
                return this.paySlipAnnexes[0].id;
            }
            return null;
        },
        getMin() {
            if(this.paySlipAnnexes.length > 0) {
                return this.paySlipAnnexes.reduce((min, obj) => {
                    return obj.id < min.id ? obj : min;
                }, {id: Infinity}).id;
            }
            return null;
        },
        setAnnexId(annexId) {
            this.annexId = annexId;
        },
        setPaySlipAnnex(paySlipAnnex) {
            this.paySlipAnnex = paySlipAnnex
        },
        setPaySlipAnnexes(paySlipAnnexes) {
            this.paySlipAnnexes = paySlipAnnexes
        },
        addPaySlipAnnex(paySlipAnnex) {
            this.paySlipAnnexes.unshift(paySlipAnnex)
        },
        updatePaySlipAnnex(paySlipAnnex) {
            let index = this.paySlipAnnexes.findIndex(cl => cl.id === paySlipAnnex.id)
            this.paySlipAnnexes.splice(index, 1, paySlipAnnex)
        },
        deletePaySlipAnnex(paySlipAnnex) {
            let index = this.paySlipAnnexes.findIndex(cl => cl.id === paySlipAnnex.id)
            this.paySlipAnnexes.splice(index, 1)
        },
    },
});